import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const getCaptchaData = () => {
	return axios.post(`${API_URL}/leads`, null).catch((err) => {
		if (err.response.status === 499) {
			return err.response.data.captcha;
		}
		return err.response;
	});
};

export const postImage = (file) => {
	const formData = new FormData();
	formData.append('files', file);
	formData.append('dmsc', 1);

	return axios
		.post(`${API_URL}/uploads`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		.then((res) => res.data.uploads[0])
		.catch((err) => err);
};

export const postApplicationData = (captchaToken, captchaValue, stateData) => {
	const captchaQuery = `?token=${captchaToken}&value=${captchaValue}`;
	const attachments = [];

	stateData.configuration.elevators.forEach((item) => {
		if (item.image_door) {
			attachments.push({ ...item.image_door, label: `${item.display_name} - Aufzugstür`});
			item.image_door = `${item.display_name} - Aufzugstür`;
		}

		if (item.image_cabin) {
			attachments.push({ ...item.image_cabin, label: `${item.display_name} - Kabine Innen` });
			item.image_cabin = `${item.display_name} - Kabine Innen`;
		}
	});

	const data = {
		lead: {
			...stateData.lead,
			extended_data: {
				...stateData.configuration,
				attachments: attachments,
			},
		},
	};

	console.log(data);

	return axios
		.post(`${API_URL}/leads${captchaQuery}`, data)
		.then((res) => res)
		.catch((err) => err);
};
